import { type ComponentProps } from "react"
import { cn } from "@local/utils/src/cn"

interface Props {
  className?: string
}

export const BurgerMenuMobile = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2.5em"
    height="2.5em"
    viewBox="0 0 40 40"
    aria-hidden="true"
  >
    <g stroke="currentColor" strokeLinecap="round" strokeWidth="2">
      <path d="M2.5 11.962H38M2.5 20H38M2.5 28.038H38" />
    </g>
  </svg>
)

export const BasketIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.375em"
    height="1.375em"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <g fill="currentColor" transform="translate(0 0.5455) scale(1.0909)">
      <path d="M8.629 12.572c.505 0 .914.383.914.857v2.285c0 .474-.41.857-.914.857-.505 0-.915-.383-.915-.857V13.43c0-.474.41-.857.915-.857ZM14.419 13.429c0-.474-.41-.857-.914-.857-.505 0-.915.383-.915.857v2.285c0 .474.41.857.915.857.505 0 .914-.383.914-.857V13.43Z" />
      <path
        fillRule="evenodd"
        d="M8.201 1.286c.253-.41.103-.934-.334-1.171-.438-.237-.997-.096-1.25.314L4.18 4.388a.832.832 0 0 0-.085.184h-.343C1.901 4.572.4 5.979.4 7.714c0 .982.48 1.859 1.233 2.435l.813 5.24.544 2.392c.327 1.433 1.575 2.522 3.123 2.724 3.287.429 6.62.429 9.907 0 1.549-.202 2.797-1.29 3.123-2.724l.545-2.392.813-5.24c.752-.576 1.232-1.453 1.232-2.435 0-1.735-1.5-3.142-3.352-3.142h-.343a.832.832 0 0 0-.084-.184L15.516.428c-.253-.41-.812-.55-1.25-.313-.437.237-.586.76-.334 1.17l2.024 3.287H6.178L8.2 1.286Zm10.343 9.568a3.663 3.663 0 0 1-.163.003H3.752l-.162-.003.656 4.232.533 2.337c.165.729.8 1.282 1.586 1.384 3.12.407 6.284.407 9.403 0 .787-.102 1.421-.655 1.587-1.384l.532-2.337.657-4.232ZM2.229 7.714c0-.789.682-1.428 1.523-1.428h14.629c.842 0 1.524.64 1.524 1.428 0 .79-.682 1.429-1.524 1.429H3.752c-.841 0-1.523-.64-1.523-1.429Z"
        clipRule="evenodd"
      />
    </g>
  </svg>
)

export const UserIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    className={className}
  >
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M12 2.4a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6ZM9 7.2a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z"
        clipRule="evenodd"
      />
      <path d="M12 13.8c-2.34 0-4.5.533-6.106 1.437C4.312 16.128 3 17.51 3 19.275c0 .95.393 1.723 1.052 2.245.632.5 1.451.73 2.263.826 1.63.192 3.727.054 5.685.054 1.958 0 4.055.138 5.685-.054.812-.096 1.631-.326 2.263-.826.659-.522 1.052-1.295 1.052-2.245 0-1.765-1.312-3.147-2.894-4.038C16.5 14.333 14.34 13.8 12 13.8Zm-7.2 5.475c0-.876.672-1.808 1.976-2.542C8.06 15.945 9.898 15.6 12 15.6s3.94.345 5.224 1.133c1.304.734 1.976 1.666 1.976 2.542 0 .43-.155.673-.368.842-.24.19-.652.353-1.336.434-1.371.161-3.216.049-5.496.049s-4.125.112-5.496-.05c-.684-.08-1.096-.242-1.336-.433-.213-.169-.368-.412-.368-.842Z" />
    </g>
  </svg>
)

export const CheckMarkIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.188em"
    height="1.188em"
    fill="currentColor"
    viewBox="0 0 24 24"
    className={className}
    aria-hidden="true"
  >
    <g transform="translate(0 0.6316) scale(1.2632)">
      <path
        fill="currentColor"
        d="M6.357 7.177a.866.866 0 0 0-1.242 0 .837.837 0 0 0 0 1.225l3.639 3.85a.966.966 0 0 0 .62.262c.267 0 .533-.088.622-.35l8.697-10.76c.266-.35.266-.962-.177-1.225-.266-.262-.799-.262-1.154.175l-1.775 2.187C13.99.966 11.682.004 9.375.004 4.494.004.5 3.941.5 8.752S4.494 17.5 9.375 17.5c4.88 0 8.875-3.937 8.875-8.748 0-.787-.09-1.575-.355-2.362-.178-.437-.622-.7-1.065-.612-.444.087-.71.612-.622 1.05.178.612.267 1.312.267 1.924 0 3.85-3.195 6.998-7.1 6.998s-7.1-3.149-7.1-6.998 3.195-6.998 7.1-6.998c1.952 0 3.727.787 5.147 2.187l-5.147 6.386-3.018-3.15Z"
      />
    </g>
  </svg>
)

export const CloseIcon = ({ className }: Props) => (
  <svg
    width="1.063em"
    height="1.063em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <g transform="scale(1.4118)">
      <path
        d="M16 1L1 16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M0.999999 1L16 16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
  </svg>
)

export const ArrowDownIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2.188em"
    height="1.063em"
    viewBox="0 0 35 17"
    fill="currentColor"
    aria-hidden="true"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.2225 5.86244C23.5925 6.2324 23.5925 6.83225 23.2225 7.20218L18.1699 12.2548C17.7999 12.6248 17.2001 12.6248 16.8302 12.2548L11.7775 7.20218C11.4075 6.83225 11.4075 6.2324 11.7775 5.86244C12.1474 5.49247 12.7473 5.49247 13.1173 5.86244L17.5 10.2451L21.8828 5.86244C22.2528 5.49247 22.8525 5.49247 23.2225 5.86244Z"
      fill="currentColor"
    />
  </svg>
)

export const ArrowUpIcon = ({ className }: Props) => (
  <ArrowDownIcon className={cn("rotate-180", className ? className : "")} />
)

export const PlusIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    width="1.5em"
    height="1.5em"
    aria-hidden="true"
    className={className}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
  </svg>
)

export const MinusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    width="1.5em"
    height="1.5em"
    aria-hidden="true"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M18 12H6" />
  </svg>
)

export const ShippingTruck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="3.125em"
    height="3.063em"
    viewBox="0 0 50 49"
    fill="currentColor"
    aria-hidden="true"
  >
    <circle cx="25" cy="24.5" r="24.5" fill="#F3F4F6" />
    <path
      d="M47.1157 22.762L44.3128 22.2015L42.2573 16.2687C41.7902 14.8672 40.4821 13.9329 38.9873 13.9329H35.0165V11.13C35.0165 9.40161 33.615 8.00015 31.8866 8.00015L8.0151 8C6.28671 8 4.88525 9.40146 4.88525 11.1298V33.74C4.88525 34.3005 5.35241 34.721 5.86624 34.721L8.85605 34.7212V34.9548C8.85605 37.7577 11.1451 40 13.9013 40C16.6575 40 18.9466 37.7109 18.9466 34.9548V34.7212H35.3436V34.9548C35.3436 37.7577 37.6327 40 40.3889 40C43.1918 40 45.4341 37.7109 45.4341 34.9548V34.7212H48.237C48.7975 34.7212 49.218 34.254 49.218 33.7402V25.3314C49.2645 24.1167 48.377 22.9956 47.1157 22.762ZM13.9012 38.0846C12.2195 38.0846 10.818 36.6832 10.818 35.0015C10.818 33.3198 12.2195 31.9183 13.9012 31.9183C15.5829 31.9183 16.9844 33.3198 16.9844 35.0015C16.9844 36.6832 15.6296 38.0846 13.9012 38.0846ZM35.0165 22.0613V15.9416H39.034C39.6414 15.9416 40.2019 16.3154 40.3888 16.9226L42.164 22.0613L35.0165 22.0613ZM40.4355 38.0846C38.7537 38.0846 37.3523 36.6832 37.3523 35.0015C37.3523 33.3198 38.7537 31.9183 40.4355 31.9183C42.1172 31.9183 43.5186 33.3198 43.5186 35.0015C43.5186 36.6832 42.1172 38.0846 40.4355 38.0846Z"
      fill="currentColor"
    />
    <path
      d="M14.1353 24.7239L18.9469 26.9194V20.8464L14.1353 18.6509V24.7239Z"
      fill="currentColor"
    />
    <path
      d="M19.9274 15.1006L15.5361 17.1093L19.9274 19.1181L24.3653 17.1093L19.9274 15.1006Z"
      fill="currentColor"
    />
    <path
      d="M20.9551 26.9197L25.7668 24.7241V18.6511L20.9551 20.8467V26.9197Z"
      fill="currentColor"
    />
  </svg>
)

export const ThankYouBadgeIcon = ({ className }: Props) => (
  <svg
    width="3.375em"
    height="3.625em"
    viewBox="0 0 54 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <g id="check-icon" filter="url(#filter0_d_31_11230)">
      <path
        id="Vector"
        d="M43.8677 12.9005L30.8146 6.79014C28.4986 5.73662 25.5511 5.73662 23.2352 6.79014L10.182 12.9005C7.23454 14.3754 5.55024 17.7467 5.97132 21.1179C7.02401 28.0711 10.3926 41.1347 22.3931 50.827C23.867 51.8806 25.5511 52.3019 27.025 52.3019C28.4986 52.3019 30.183 51.6699 31.4462 50.6163C43.4468 40.924 47.0257 27.8604 47.868 20.9072C48.4996 17.7467 46.8153 14.3754 43.8677 12.9005Z"
        fill="#05A067"
      />
      <path
        id="Vector_2"
        d="M25.9013 35.8858C25.27 35.8858 24.6386 35.6754 24.2176 35.044L18.5351 28.0987C17.6933 27.2568 17.9037 25.7836 18.7456 25.1522C19.5874 24.3103 21.0607 24.5208 21.6921 25.3627L25.9013 30.4138L34.7408 19.6802C35.5827 18.8383 36.8454 18.6278 37.6873 19.4697C38.5292 20.3116 38.7396 21.5743 37.8978 22.4162L27.3746 35.044C27.1641 35.6754 26.5327 35.8858 25.9013 35.8858Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_31_11230"
        x="0.639596"
        y="0.732308"
        width="52.6281"
        height="56.8373"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2.63385" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31_11230"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_31_11230"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)

export const TrashIcon = ({ className }: Props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <g transform="translate(0.7059 0) scale(1.4118)">
      <path
        d="M6.16671 2.5C6.16671 2.22386 6.39057 2 6.66671 2H9.33337C9.60951 2 9.83337 2.22386 9.83337 2.5V3H12.6667C12.9428 3 13.1667 3.22386 13.1667 3.5C13.1667 3.77614 12.9428 4 12.6667 4H3.33337C3.05723 4 2.83337 3.77614 2.83337 3.5C2.83337 3.22386 3.05723 3 3.33337 3H6.16671V2.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.15971 5.79652C4.17846 5.62771 4.32115 5.5 4.491 5.5H11.5086C11.6784 5.5 11.8211 5.62771 11.8398 5.79652L11.9732 6.99742C12.2138 9.16207 12.2138 11.3467 11.9732 13.5113L11.9601 13.6296C11.8725 14.4179 11.2615 15.0466 10.476 15.1566C8.83318 15.3866 7.16638 15.3866 5.5236 15.1566C4.73802 15.0466 4.12701 14.4179 4.03941 13.6296L4.02628 13.5113C3.78576 11.3467 3.78576 9.16207 4.02628 6.99742L4.15971 5.79652ZM7.16644 8.1C7.16644 7.82387 6.94258 7.6 6.66644 7.6C6.3903 7.6 6.16644 7.82387 6.16644 8.1V12.7667C6.16644 13.0428 6.3903 13.2667 6.66644 13.2667C6.94258 13.2667 7.16644 13.0428 7.16644 12.7667V8.1ZM9.83311 8.1C9.83311 7.82387 9.60924 7.6 9.33311 7.6C9.05698 7.6 8.83311 7.82387 8.83311 8.1V12.7667C8.83311 13.0428 9.05698 13.2667 9.33311 13.2667C9.60924 13.2667 9.83311 13.0428 9.83311 12.7667V8.1Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export const TrashIconV2 = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.75em"
    height="1.75em"
    fill="currentColor"
    viewBox="0 0 24 24"
    className={className}
    aria-hidden="true"
  >
    <g transform="translate(3 0) scale(0.8571)">
      <path
        fill="currentColor"
        d="M14.628 27.075H5.371C3.486 27.075 2 25.247 2 23.08V10.83c0-.406.228-.677.571-.677.343 0 .572.27.572.677v12.25c0 1.49 1.028 2.64 2.228 2.64h9.257c1.257 0 2.229-1.218 2.229-2.64V10.83c0-.406.228-.677.57-.677.344 0 .572.27.572.677v12.25c0 2.166-1.543 3.994-3.371 3.994Zm3.029-23.758h-4.343C13.028 1.42 11.657 0 10 0S6.97 1.421 6.685 3.317H2.343C1.029 3.317 0 4.535 0 6.092s1.029 2.707 2.343 2.707h15.37c1.315 0 2.343-1.218 2.343-2.775s-1.085-2.707-2.4-2.707ZM10 1.354c1.028 0 1.885.812 2.114 1.963H7.828C8.114 2.166 8.971 1.354 10 1.354Zm7.657 6.092H2.343c-.629 0-1.2-.61-1.2-1.422 0-.744.514-1.421 1.2-1.421h15.37c.63 0 1.2.609 1.2 1.421-.056.812-.57 1.422-1.256 1.422Z"
      />
      <path
        fill="currentColor"
        d="M6 23.758c-.343 0-.572-.27-.572-.677V11.778c0-.407.229-.677.572-.677.342 0 .571.27.571.676v11.304c0 .339-.286.677-.571.677Zm8 0c-.344 0-.572-.27-.572-.677V11.778c0-.407.228-.677.571-.677.343 0 .572.27.572.676v11.304c0 .339-.286.677-.572.677Zm-4 0c-.343 0-.572-.27-.572-.677V11.778c0-.407.229-.677.571-.677.343 0 .572.27.572.676v11.304c0 .339-.286.677-.572.677Z"
      />
    </g>
  </svg>
)
export const SearchIcon = ({ className }: Props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      stroke="currentColor"
      strokeWidth=".804"
      d="M21.163 23.114c-4.874 3.904-12.009 3.597-16.527-.922-4.848-4.848-4.848-12.708 0-17.556 4.848-4.848 12.708-4.848 17.556 0 4.519 4.518 4.826 11.653.922 16.527l9.482 9.482a1.38 1.38 0 0 1-1.95 1.951l-9.483-9.482ZM6.587 20.242c-3.771-3.771-3.771-9.885 0-13.655A9.655 9.655 0 0 1 20.25 20.233l-.009.009-.008.008c-3.771 3.762-9.878 3.76-13.646-.008Z"
      clipRule="evenodd"
    />
  </svg>
)

export const FolderIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    className={className}
    aria-hidden="true"
  >
    <path d="M19,3H12.472a1.019,1.019,0,0,1-.447-.1L8.869,1.316A3.014,3.014,0,0,0,7.528,1H5A5.006,5.006,0,0,0,0,6V18a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V8A5.006,5.006,0,0,0,19,3ZM5,3H7.528a1.019,1.019,0,0,1,.447.1l3.156,1.579A3.014,3.014,0,0,0,12.472,5H19a3,3,0,0,1,2.779,1.882L2,6.994V6A3,3,0,0,1,5,3ZM19,21H5a3,3,0,0,1-3-3V8.994l20-.113V18A3,3,0,0,1,19,21Z" />
  </svg>
)

export const FileIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    className={className}
    aria-hidden="true"
  >
    <path d="M19.949,5.536,16.465,2.05A6.958,6.958,0,0,0,11.515,0H7A5.006,5.006,0,0,0,2,5V19a5.006,5.006,0,0,0,5,5H17a5.006,5.006,0,0,0,5-5V10.485A6.951,6.951,0,0,0,19.949,5.536ZM18.535,6.95A4.983,4.983,0,0,1,19.316,8H15a1,1,0,0,1-1-1V2.684a5.01,5.01,0,0,1,1.051.78ZM20,19a3,3,0,0,1-3,3H7a3,3,0,0,1-3-3V5A3,3,0,0,1,7,2h4.515c.164,0,.323.032.485.047V7a3,3,0,0,0,3,3h4.953c.015.162.047.32.047.485Z" />
  </svg>
)

export const DownloadIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    className={className}
    aria-hidden="true"
  >
    <path d="M9.878,18.122a3,3,0,0,0,4.244,0l3.211-3.211A1,1,0,0,0,15.919,13.5l-2.926,2.927L13,1a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1l-.009,15.408L8.081,13.5a1,1,0,0,0-1.414,1.415Z" />
    <path d="M23,16h0a1,1,0,0,0-1,1v4a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V17a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v4a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V17A1,1,0,0,0,23,16Z" />
  </svg>
)

export const ArrowLeftIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 73 59"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M37.0366 7.90828L21.3142 23.6316L72.101 23.6316L72.101 34.8162L21.8071 34.8162L37.533 50.5403L29.6236 58.4487L1.01927e-05 29.1279L29.1281 2.29461e-05L37.0366 7.90828Z"
      fill="currentColor"
    />
  </svg>
)

export const StarIcon = ({ className }: Props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
  </svg>
)

export const ArrowRightIcon = ({ className }: Props) => (
  <ArrowLeftIcon className={cn("rotate-180", className ? className : "")} />
)

export const PencilIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={className}
    aria-hidden="true"
    focusable="false"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path d="M16.938 1.063 3.874 14.124l-2.8 8.8 8.8-2.8L22.938 7.062s-.1-2.1-2-4-4-2-4-2zm.375 1.625c1.072.204 1.925.658 2.583 1.333.659.676 1.122 1.574 1.416 2.667L19.5 8.5l-4-4 1.438-1.438.375-.374zM4.979 15.127c.011.003 1.202.304 2.396 1.498 1.3 1.2 1.5 2.3 1.5 2.3l.043.052-3.549 1.142-1.496-1.496 1.106-3.496z" />
  </svg>
)

export const ShoppingCartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g transform="translate(0 1.3333) scale(0.8889)">
      <path
        d="M0.84967 1.77337H5.52627C5.25368 1.55761 4.97826 1.33889 4.70567 1.12313C4.84196 1.55465 4.97826 1.98617 5.11455 2.42064C5.44393 3.45806 5.77047 4.49548 6.09985 5.5329C6.49453 6.78017 6.89206 8.03039 7.28674 9.28061C7.63032 10.3653 7.9739 11.45 8.31463 12.5347C8.48216 13.0608 8.64117 13.5899 8.81438 14.113C8.81722 14.1219 8.82006 14.1278 8.8229 14.1367C8.96203 14.5771 9.41918 14.9081 9.87066 14.7574C10.2909 14.6155 10.6146 14.1396 10.4669 13.6667C10.3307 13.2352 10.1944 12.8037 10.0581 12.3692C9.72869 11.3318 9.40215 10.2944 9.07277 9.25697C8.67808 8.00675 8.2834 6.75652 7.88587 5.5063C7.5423 4.42159 7.19872 3.33688 6.85798 2.25217C6.69046 1.72608 6.53429 1.19702 6.35824 0.673879C6.3554 0.665012 6.35256 0.659101 6.34972 0.650234C6.23046 0.277827 5.91528 0 5.52911 0H0.85251C0.406713 0 -0.0192068 0.407874 0.000669448 0.886683C0.0177063 1.36845 0.37264 1.77337 0.84967 1.77337Z"
        fill="black"
      />
      <path
        d="M8.90799 13.451C8.44799 14.3052 7.98516 15.1564 7.52517 16.0106C7.45986 16.1347 7.39171 16.2559 7.3264 16.3801C7.01122 16.9623 7.40875 17.713 8.06183 17.713H21.0666C21.6657 17.713 22.2677 17.7249 22.8697 17.713H22.8952C23.341 17.713 23.7669 17.3052 23.747 16.8263C23.7272 16.3446 23.3722 15.9397 22.8952 15.9397H9.89044C9.29132 15.9397 8.68651 15.9219 8.08738 15.9397H8.06183C8.30602 16.383 8.55305 16.8293 8.79725 17.2726C9.25724 16.4185 9.72007 15.5673 10.1801 14.7131C10.2454 14.589 10.3135 14.4678 10.3788 14.3436C10.5975 13.9387 10.4839 13.3565 10.0722 13.1318C9.66896 12.9131 9.14082 13.0195 8.90799 13.451Z"
        fill="black"
      />
      <path
        d="M20.2518 23.4084C21.3197 23.4084 22.1855 22.5072 22.1855 21.3956C22.1855 20.284 21.3197 19.3828 20.2518 19.3828C19.1839 19.3828 18.3181 20.284 18.3181 21.3956C18.3181 22.5072 19.1839 23.4084 20.2518 23.4084Z"
        fill="black"
      />
      <path
        d="M17.75 21.3956C17.7614 22.5039 18.4287 23.4615 19.4196 23.8487C20.3567 24.2152 21.5095 23.896 22.1484 23.0921C22.827 22.2349 22.9633 21.0143 22.3982 20.0507C21.8417 19.099 20.7741 18.635 19.732 18.8478C18.582 19.0813 17.7614 20.1956 17.75 21.3956C17.7472 21.7059 18.0141 22.0015 18.3179 21.9867C18.6274 21.9719 18.883 21.7266 18.8858 21.3956C18.8858 21.3483 18.8886 21.298 18.8915 21.2507C18.8915 21.23 18.8943 21.2093 18.8972 21.1887C18.9057 21.0704 18.8943 21.2271 18.8915 21.2241C18.8716 21.2123 18.9511 20.9581 18.9596 20.9345C18.9682 20.9108 18.9852 20.8103 19.0051 20.8044C19.0107 20.8015 18.954 20.9138 18.9852 20.8547C18.9965 20.831 19.0079 20.8074 19.0164 20.7837C19.059 20.6951 19.1101 20.6153 19.1612 20.5325C19.2152 20.4468 19.0846 20.6241 19.1754 20.5148C19.2038 20.4823 19.2322 20.4468 19.2635 20.4143C19.2947 20.3818 19.3259 20.3493 19.3572 20.3197C19.3714 20.3079 19.3856 20.2931 19.3998 20.2813C19.4196 20.2636 19.502 20.2222 19.4281 20.2547C19.3657 20.2813 19.4111 20.2695 19.431 20.2547C19.4509 20.2399 19.4707 20.2251 19.4935 20.2104C19.5247 20.1897 19.5559 20.169 19.59 20.1512C19.6326 20.1246 19.678 20.104 19.7235 20.0803C19.7377 20.0714 19.7973 20.0419 19.7235 20.0773C19.6383 20.1187 19.7518 20.0685 19.7604 20.0655C19.837 20.036 19.9194 20.0123 19.9989 19.9946C20.0244 19.9887 20.05 19.9857 20.0755 19.9798C20.138 19.965 20.0216 19.9857 20.0216 19.9857C20.0727 19.9857 20.1267 19.9739 20.1778 19.9739C20.2715 19.9709 20.3623 19.9739 20.456 19.9828C20.5611 19.9916 20.3481 19.9621 20.4788 19.9887C20.5299 19.9975 20.5781 20.0123 20.6292 20.0241C20.6718 20.036 20.7144 20.0507 20.757 20.0655C20.7684 20.0685 20.8252 20.0892 20.828 20.0921C20.8308 20.101 20.7229 20.036 20.7797 20.0714C20.8592 20.1217 20.9473 20.1601 21.0268 20.2133C21.0466 20.2281 21.0665 20.2429 21.0892 20.2576C21.1091 20.2724 21.1517 20.2842 21.0921 20.2576C21.0353 20.234 21.0722 20.2399 21.0921 20.2606C21.112 20.2783 21.129 20.2931 21.1489 20.3108C21.2199 20.3759 21.2795 20.4468 21.342 20.5177C21.4271 20.6153 21.3022 20.4498 21.3561 20.5355C21.3789 20.5739 21.4044 20.6094 21.4271 20.6478C21.4499 20.6862 21.4726 20.7276 21.4924 20.766L21.518 20.8192C21.5719 20.9256 21.5294 20.8103 21.5152 20.8044C21.5492 20.8163 21.5861 21.0291 21.5975 21.0675C21.606 21.1059 21.6145 21.1473 21.6231 21.1857C21.6458 21.298 21.6202 21.1502 21.6202 21.1473C21.6344 21.1621 21.6287 21.23 21.6287 21.2478C21.6344 21.3364 21.6344 21.4281 21.6287 21.5167C21.6259 21.5433 21.6231 21.5699 21.6231 21.5995C21.6202 21.6586 21.589 21.6497 21.6287 21.564C21.6089 21.6084 21.6089 21.6734 21.5975 21.7207C21.5776 21.8034 21.5464 21.8832 21.5237 21.966C21.501 22.0399 21.5748 21.8655 21.5379 21.9335C21.5294 21.9482 21.5208 21.9689 21.5152 21.9867C21.4924 22.034 21.4697 22.0783 21.4442 22.1226C21.4215 22.1611 21.3987 22.1995 21.3732 22.2379C21.2965 22.3591 21.4271 22.1788 21.3618 22.2586C21.2994 22.3325 21.2397 22.4034 21.1687 22.4684C21.1574 22.4803 21.0892 22.5571 21.0694 22.5571C21.0694 22.5571 21.1858 22.4743 21.0949 22.5335C21.0779 22.5453 21.0637 22.5541 21.0495 22.566C20.97 22.6192 20.8876 22.6635 20.8053 22.7078C20.7173 22.7551 20.9075 22.6724 20.7854 22.7167C20.7428 22.7315 20.7031 22.7463 20.6605 22.761C20.6179 22.7729 20.5753 22.7847 20.5299 22.7965C20.51 22.7995 20.4929 22.8054 20.4731 22.8083C20.3481 22.8379 20.5639 22.8024 20.4901 22.8083C20.3964 22.8172 20.3055 22.8231 20.2118 22.8202C20.1664 22.8202 20.121 22.8142 20.0727 22.8113C20.0557 22.8113 19.9875 22.8024 20.0699 22.8113C20.1636 22.8202 20.05 22.8054 20.0301 22.8024C19.9307 22.7817 19.8342 22.7492 19.7377 22.7138C19.7206 22.7078 19.6638 22.6783 19.7348 22.7138C19.8172 22.7551 19.7178 22.7049 19.7007 22.696C19.6553 22.6724 19.6127 22.6487 19.5701 22.6221C19.5275 22.5955 19.4878 22.566 19.4452 22.5364C19.377 22.4921 19.4537 22.5601 19.4707 22.5601C19.4594 22.5601 19.4225 22.5187 19.414 22.5098C19.3401 22.4418 19.2691 22.3709 19.2038 22.2911C19.2038 22.2911 19.1556 22.2409 19.1556 22.232C19.1556 22.2438 19.2237 22.3325 19.1783 22.2586C19.1499 22.2143 19.1215 22.1729 19.0959 22.1285C19.0675 22.0783 19.042 22.0251 19.0164 21.9749C18.9568 21.8537 19.0448 22.0694 18.9994 21.9364C18.9653 21.8359 18.9369 21.7354 18.917 21.629C18.9142 21.6113 18.9142 21.5847 18.9057 21.5699C18.9483 21.6675 18.9142 21.6527 18.9085 21.5847C18.9028 21.5226 18.9 21.4606 18.9 21.3985C18.8972 21.0882 18.6416 20.7926 18.3321 20.8074C18.0141 20.8163 17.7472 21.0645 17.75 21.3956Z"
        fill="black"
      />
      <path
        d="M10.4642 23.4084C11.5321 23.4084 12.3979 22.5072 12.3979 21.3956C12.3979 20.284 11.5321 19.3828 10.4642 19.3828C9.39625 19.3828 8.53052 20.284 8.53052 21.3956C8.53052 22.5072 9.39625 23.4084 10.4642 23.4084Z"
        fill="black"
      />
      <path
        d="M7.9625 21.3955C7.97386 22.5038 8.64113 23.4615 9.63211 23.8486C10.5691 24.2151 11.722 23.8959 12.3608 23.092C13.0395 22.2349 13.1758 21.0142 12.6107 20.0507C12.0542 19.099 10.9865 18.6349 9.94445 18.8477C8.79163 19.0812 7.97386 20.1955 7.9625 21.3955C7.95966 21.7058 8.22657 22.0014 8.53039 21.9866C8.8399 21.9718 9.09545 21.7265 9.09829 21.3955C9.09829 21.3482 9.10113 21.2979 9.10397 21.2507C9.10397 21.23 9.10681 21.2093 9.10965 21.1886C9.11816 21.0704 9.10681 21.227 9.10397 21.2241C9.08409 21.2122 9.1636 20.9581 9.17211 20.9344C9.18063 20.9108 9.19767 20.8103 9.21755 20.8044C9.22322 20.8014 9.16644 20.9137 9.19767 20.8546C9.20903 20.831 9.22038 20.8073 9.2289 20.7837C9.2715 20.695 9.32261 20.6152 9.37372 20.5324C9.42767 20.4467 9.29705 20.6241 9.38791 20.5147C9.41631 20.4822 9.4447 20.4467 9.47594 20.4142C9.50717 20.3817 9.53841 20.3492 9.56964 20.3196C9.58384 20.3078 9.59803 20.293 9.61223 20.2812C9.63211 20.2635 9.71445 20.2221 9.64063 20.2546C9.57816 20.2812 9.62359 20.2694 9.64347 20.2546C9.66334 20.2398 9.68322 20.2251 9.70593 20.2103C9.73717 20.1896 9.7684 20.1689 9.80248 20.1512C9.84507 20.1246 9.8905 20.1039 9.93593 20.0802C9.95013 20.0714 10.0098 20.0418 9.93593 20.0773C9.85075 20.1187 9.96433 20.0684 9.97284 20.0655C10.0495 20.0359 10.1319 20.0123 10.2114 19.9945C10.2369 19.9886 10.2625 19.9857 10.288 19.9797C10.3505 19.965 10.2341 19.9857 10.2341 19.9857C10.2852 19.9857 10.3391 19.9738 10.3902 19.9738C10.4839 19.9709 10.5748 19.9738 10.6685 19.9827C10.7736 19.9916 10.5606 19.962 10.6912 19.9886C10.7423 19.9975 10.7906 20.0123 10.8417 20.0241C10.8843 20.0359 10.9269 20.0507 10.9695 20.0655C10.9809 20.0684 11.0376 20.0891 11.0405 20.0921C11.0433 20.1009 10.9354 20.0359 10.9922 20.0714C11.0717 20.1216 11.1597 20.16 11.2392 20.2132C11.2591 20.228 11.279 20.2428 11.3017 20.2576C11.3216 20.2724 11.3642 20.2842 11.3046 20.2576C11.2478 20.2339 11.2847 20.2398 11.3046 20.2605C11.3244 20.2783 11.3415 20.293 11.3613 20.3108C11.4323 20.3758 11.492 20.4467 11.5544 20.5177C11.6396 20.6152 11.5147 20.4497 11.5686 20.5354C11.5913 20.5738 11.6169 20.6093 11.6396 20.6477C11.6623 20.6861 11.685 20.7275 11.7049 20.7659L11.7305 20.8191C11.7844 20.9255 11.7418 20.8103 11.7276 20.8044C11.7617 20.8162 11.7986 21.029 11.81 21.0674C11.8185 21.1058 11.827 21.1472 11.8355 21.1856C11.8583 21.2979 11.8327 21.1502 11.8327 21.1472C11.8469 21.162 11.8412 21.23 11.8412 21.2477C11.8469 21.3364 11.8469 21.428 11.8412 21.5167C11.8384 21.5433 11.8355 21.5699 11.8355 21.5994C11.8327 21.6585 11.8015 21.6497 11.8412 21.564C11.8213 21.6083 11.8213 21.6733 11.81 21.7206C11.7901 21.8034 11.7589 21.8832 11.7362 21.9659C11.7134 22.0398 11.7873 21.8654 11.7504 21.9334C11.7418 21.9482 11.7333 21.9689 11.7276 21.9866C11.7049 22.0339 11.6822 22.0782 11.6566 22.1226C11.6339 22.161 11.6112 22.1994 11.5857 22.2378C11.509 22.359 11.6396 22.1787 11.5743 22.2585C11.5118 22.3324 11.4522 22.4033 11.3812 22.4684C11.3699 22.4802 11.3017 22.557 11.2818 22.557C11.2818 22.557 11.3983 22.4743 11.3074 22.5334C11.2904 22.5452 11.2762 22.5541 11.262 22.5659C11.1825 22.6191 11.1001 22.6634 11.0178 22.7078C10.9297 22.7551 11.12 22.6723 10.9979 22.7166C10.9553 22.7314 10.9155 22.7462 10.873 22.761C10.8304 22.7728 10.7878 22.7846 10.7423 22.7964C10.7225 22.7994 10.7054 22.8053 10.6856 22.8083C10.5606 22.8378 10.7764 22.8024 10.7026 22.8083C10.6089 22.8171 10.518 22.823 10.4243 22.8201C10.3789 22.8201 10.3335 22.8142 10.2852 22.8112C10.2681 22.8112 10.2 22.8024 10.2823 22.8112C10.376 22.8201 10.2625 22.8053 10.2426 22.8024C10.1432 22.7817 10.0467 22.7492 9.95013 22.7137C9.93309 22.7078 9.8763 22.6782 9.94729 22.7137C10.0296 22.7551 9.93025 22.7048 9.91322 22.696C9.86778 22.6723 9.82519 22.6487 9.7826 22.6221C9.74001 22.5955 9.70025 22.5659 9.65766 22.5363C9.58952 22.492 9.66618 22.56 9.68322 22.56C9.67186 22.56 9.63495 22.5186 9.62643 22.5097C9.5526 22.4418 9.48162 22.3708 9.41631 22.291C9.41631 22.291 9.36804 22.2408 9.36804 22.2319C9.36804 22.2437 9.43618 22.3324 9.39075 22.2585C9.36236 22.2142 9.33396 22.1728 9.30841 22.1285C9.28001 22.0782 9.25446 22.025 9.2289 21.9748C9.16927 21.8536 9.2573 22.0694 9.21187 21.9364C9.17779 21.8359 9.1494 21.7354 9.12952 21.629C9.12668 21.6112 9.12668 21.5846 9.11816 21.5699C9.16076 21.6674 9.12668 21.6526 9.121 21.5846C9.11532 21.5226 9.11249 21.4605 9.11249 21.3984C9.10965 21.0881 8.85409 20.7925 8.54459 20.8073C8.22373 20.8162 7.95682 21.0645 7.9625 21.3955ZM26.3367 4.64014L22.8896 13.8912H9.64347L6.71313 4.64014H26.3367Z"
        fill="black"
      />
      <path
        d="M25.7889 4.47766C25.3999 5.52099 25.0137 6.56431 24.6247 7.60764C24.0057 9.27165 23.3867 10.9327 22.7705 12.5967C22.6286 12.978 22.4866 13.3622 22.3446 13.7435C22.5263 13.5987 22.7109 13.4538 22.8926 13.309H11.2764C10.7425 13.309 10.203 13.2854 9.66639 13.309H9.64367C9.8254 13.4538 10.01 13.5987 10.1917 13.7435C9.85947 12.6942 9.53009 11.648 9.19787 10.5987C8.67257 8.94062 8.14727 7.28253 7.62481 5.62148C7.50271 5.2402 7.38345 4.85893 7.26136 4.4747C7.07963 4.72297 6.89506 4.9742 6.71334 5.22247H25.5419C25.7974 5.22247 26.053 5.22838 26.3057 5.22247H26.3398C26.6379 5.22247 26.9218 4.95055 26.9076 4.63135C26.8935 4.31214 26.6578 4.04022 26.3398 4.04022H7.51123C7.25568 4.04022 7.00012 4.03431 6.74741 4.04022H6.71334C6.3584 4.04022 6.0489 4.4215 6.16532 4.78799C6.49754 5.83724 6.82692 6.88352 7.15913 7.93276C7.68444 9.59086 8.20974 11.249 8.7322 12.91C8.8543 13.2913 8.97356 13.6726 9.09565 14.0568C9.17516 14.3051 9.38528 14.4913 9.64367 14.4913H21.2599C21.7938 14.4913 22.3333 14.5119 22.8699 14.4913H22.8926C23.1624 14.4913 23.3498 14.3021 23.4407 14.0568C23.8297 13.0135 24.2158 11.9701 24.6048 10.9268C25.2238 9.26279 25.8428 7.60173 26.459 5.93773C26.601 5.55645 26.743 5.17222 26.8849 4.79095C26.9928 4.5013 26.7657 4.12889 26.4874 4.06387C26.1609 3.98702 25.9025 4.16732 25.7889 4.47766Z"
        fill="black"
      />
    </g>
  </svg>
)

export const ChevronUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g transform="translate(0 5.25) scale(1.5)">
      <path d="M15 8L8 1L1 8" stroke="black" />
    </g>
  </svg>
)

export const ChevronRightIcon = ({ className }: { className?: string }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g transform="translate(5.4 0) scale(1.2)">
      <path d="M1 1L10 10L1 19" stroke="currentColor" />
    </g>
  </svg>
)

export const ChevronLeftIcon = ({ className }: { className?: string }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g transform="translate(5.4 0) scale(1.2)">
      <path d="M10 19L0.999999 10L10 1" stroke="currentColor" />
    </g>
  </svg>
)

export const ChevronDownIcon = ({ className }: { className?: string }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g transform="translate(0 5.3333) scale(1.3333)">
      <path d="M17 0.5L9 8.5L1 0.5" stroke="currentColor" />
    </g>
  </svg>
)

export const PhoneIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={className || "h-5 w-5"}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
    />
  </svg>
)

export const XMarkIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
)

export const MenuIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    />
  </svg>
)

export const ArrowLeftCarouselIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 19.5L8.25 12l7.5-7.5"
    />
  </svg>
)

export const XCircleIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
)

// TODO: Most icons are monochromatic and could use "currentColor" on fill/stroke.
// TODO: Most icons could leverage font-sizes also, by converting width/height to em while keeping the viewBox.

export const CartIcon = (props: ComponentProps<"svg">) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#cart-icon-clip)" transform="scale(0.8)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.9346 6.5625H7.66893L6.19371 3.91825C6.02813 3.62144 5.71487 3.4375 5.375 3.4375H3.5C2.98224 3.4375 2.5625 3.85724 2.5625 4.375C2.5625 4.89276 2.98224 5.3125 3.5 5.3125H4.8245L6.28036 7.92206L9.63796 15.3511L9.6414 15.3586L9.93714 16.013L6.56609 19.6088C6.32369 19.8674 6.24781 20.2405 6.36999 20.5731C6.49215 20.9059 6.79146 21.1413 7.14357 21.1815L10.2162 21.5326C14.0596 21.9719 17.9405 21.9719 21.7838 21.5326L24.8565 21.1815C25.3709 21.1226 25.7402 20.658 25.6815 20.1435C25.6226 19.6291 25.158 19.2598 24.6436 19.3186L21.5709 19.6698C17.869 20.0928 14.131 20.0928 10.4291 19.6698L9.20974 19.5304L11.684 16.8913C11.7079 16.8656 11.7301 16.8391 11.7507 16.8118L12.6917 16.9343C14.0104 17.1059 15.3433 17.1395 16.6689 17.0346C19.7607 16.7901 22.6263 15.3189 24.6269 12.9489L25.3494 12.0928C25.3738 12.0641 25.3963 12.0339 25.4169 12.0024L26.7636 9.95011C27.7181 8.49541 26.6746 6.5625 24.9346 6.5625ZM11.8203 14.93C11.6136 14.9031 11.4353 14.7719 11.3482 14.5825L11.3466 14.5789L8.57092 8.4375H24.9346C25.1832 8.4375 25.3323 8.71363 25.1959 8.92145L23.8802 10.9265L23.194 11.7394C21.5165 13.7268 19.1136 14.9604 16.5211 15.1655C15.3254 15.26 14.123 15.2296 12.9336 15.0749L11.8203 14.93Z"
        fill="currentColor"
      />
      <path
        d="M9.125 23.125C8.08946 23.125 7.25 23.9645 7.25 25C7.25 26.0355 8.08946 26.875 9.125 26.875C10.1605 26.875 11 26.0355 11 25C11 23.9645 10.1605 23.125 9.125 23.125Z"
        fill="currentColor"
      />
      <path
        d="M21 25C21 23.9645 21.8395 23.125 22.875 23.125C23.9105 23.125 24.75 23.9645 24.75 25C24.75 26.0355 23.9105 26.875 22.875 26.875C21.8395 26.875 21 26.0355 21 25Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="cart-icon-clip">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const BackButtonArrowIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.688em"
    height="0.688em"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <g transform="translate(0 3.2727) scale(2.1818)">
      <path
        fill="currentColor"
        d="M.146 3.328a.5.5 0 0 0 0 .708l3.182 3.182a.5.5 0 1 0 .708-.708L1.207 3.682 4.036.854a.5.5 0 1 0-.708-.708L.146 3.328Zm10.354.354v-.5H.5v1h10v-.5Z"
      />
    </g>
  </svg>
)

export const BshGiftCardIcon = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2.9375em"
    height="2em"
    viewBox="0 0 47 32"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <g clipPath="url(#bsh-gift-card-clip)">
      <path fill="#000" d="M0 7.116 42.379 0l4.099 24.413L4.099 31.53z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M27.268 4.8a13.4 13.4 0 0 0-2.315-2.214A22.6 22.6 0 0 1 20.049 4.5c.538.192 1.478.599 2.243.934.676.29 1.382-.09 2.09-.452.3-.15.614-.325.9-.433 0 0 .016.219.013.441.004.262.01.543.03.54 0 0 2.49 1.68 3.464 6.76.324-1.93.28-3.88-.121-5.789-.178-.212-.723-.927-1.42-1.697zM-.167 9.405a47 47 0 0 0-.787 2.068 15.5 15.5 0 0 0 1.776 5.51c-.735-5.1 1.066-7.52 1.066-7.52s-.053-.193-.128-.402c-.083-.248-.171-.536-.152-.54a7 7 0 0 1 1.011.113c.792.13 1.6.236 2.124-.255.614-.567 1.391-1.243 1.815-1.616q-2.64.2-5.26-.206c-.6.887-1.105 1.86-1.465 2.848M12.56 28.164l4.573.583 4.152-2.048-4.56-.505zm1.279-7.94 2.016 1.154 1.53-1.749-1.744.474zm9.903-2.53c1.807 2.682 2.226 6.746.636 10.543 9.202-5.982 4.151-14.23 4.151-14.23a25.5 25.5 0 0 1-6.956-6.699 7.34 7.34 0 0 0-7.83 1.133c-1.74-.716-3.68-.693-5.422.023a8.4 8.4 0 0 0-2.35 1.444 25.5 25.5 0 0 1-4.388 8.602 10.6 10.6 0 0 0 .015 3.83c.494 2.942 2.39 6.759 8.56 8.284l-.007-.039-.321-.35a11.26 11.26 0 0 1-2.537-9.8 9.26 9.26 0 0 0-.716 5.385c.053.314.106.628.1.952-2.333-2.674-3.864-4.918-3.294-7.192l1.068-2.923c1.413-4.735 4.033-3.964 6.886-3.132.447.126.893.253 1.336.36a13.7 13.7 0 0 0-1.223 2.485 13.6 13.6 0 0 0-.27 5.51l.007.04-1.006 2.69a10 10 0 0 0 1.485 2.453c.44.45 4.54-1.548 4.54-1.548-.08-.471-.5-.804-.986-.803l-1.191.018-.07-.049a7.3 7.3 0 0 1-2.065-1.932l-.06-.11.02-.125a9.3 9.3 0 0 1 1.567-3.45l.118-.14.887.092a3.9 3.9 0 0 0 2.107-.353l.808-.378.157.095a9.3 9.3 0 0 1 2.608 2.748l.06.111-.02.125a7.3 7.3 0 0 1-1.322 2.5l-.049.07-1.132.371c-.46.158-.748.61-.67 1.08 0 0 4.548.548 4.797-.018a10 10 0 0 0 .602-2.804l-1.81-2.217-.006-.04a13.3 13.3 0 0 0-2.075-5.117 15.5 15.5 0 0 0-2.013-1.981 4 4 0 0 0 .34-3.042 9.7 9.7 0 0 0-2.614-1.578c-.089-.046-.174-.072-.283-.114a8.25 8.25 0 0 1 7.383-.776c2.182 3.95 6.59 6.92 6.59 6.92 1.097 2.68 1.308 4.904.892 6.527-.34 1.348-2.02 4.857-2.543 1.375a9.1 9.1 0 0 0-2.435-4.855zm-4.703-3.163s.01.664.838.525c.827-.14.688-1.205.445-1.326zm-9.884 1.074c-.19.194.047 1.243.854 1.107.808-.135.62-.77.62-.77z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M34.219 23.705c.169.003.255.089.288.281l.016.096c.038.226-.051.346-.29.386l-1.12.188q-.047.008-.053-.036l-.233-1.387q-.009-.042.038-.052l1.097-.184c.238-.04.364.046.401.27l.014.084c.031.184-.018.294-.159.352zm-.957.025.652-.11c.12-.02.15-.057.132-.16l-.008-.05c-.018-.106-.057-.128-.177-.108l-.652.11.053.32zm.045.27.056.332.672-.113c.123-.02.15-.055.132-.16l-.01-.064c-.018-.106-.055-.128-.177-.108zm3.463-1.474q.046-.007.053.036l.031.188q.009.043-.038.052l-.907.152.054.32.742-.124q.046-.008.054.036l.03.182q.007.043-.038.052l-.743.125.056.332.906-.152q.048-.007.054.036l.031.188q.009.042-.038.052l-1.199.201q-.048.007-.055-.036l-.04-.238-.54.09-.103.271c-.011.033-.032.042-.066.048l-.277.047c-.026.004-.036-.02-.027-.041l.596-1.534c.012-.031.032-.043.066-.049l1.395-.234zm-1.093 1.132-.11-.66-.276.725zm2.99-1.111.049.29c.038.228-.048.362-.288.402l-.056.01.526.393a.025.025 0 0 1-.006.046l-.318.053c-.04.007-.058.002-.084-.02l-.494-.395-.377.063.077.454c.004.029-.013.048-.041.053l-.246.04q-.047.008-.053-.035l-.233-1.387q-.009-.043.038-.052l1.109-.186c.24-.04.364.046.401.27zm-1.096.566.644-.108c.148-.025.168-.055.148-.177l-.022-.13c-.02-.122-.051-.144-.197-.12l-.645.11zm1.735.055q.046-.008.056.036l.003.022c.011.066.044.091.116.079l.609-.102c.112-.019.135-.052.12-.14l-.017-.102c-.015-.088-.047-.111-.16-.092l-.676.113c-.238.04-.361-.046-.4-.27l-.034-.208c-.038-.227.05-.346.29-.386l.783-.132c.255-.043.36.028.4.27l.01.066q.008.045-.038.052l-.238.04q-.047.008-.053-.036l-.004-.022c-.011-.066-.046-.091-.12-.079l-.556.094c-.112.019-.136.051-.121.14l.014.085c.016.09.048.114.16.095l.675-.113c.24-.04.363.044.401.27l.037.222c.038.226-.05.346-.29.386l-.831.14c-.255.042-.359-.029-.4-.27l-.01-.067q-.008-.045.038-.052l.238-.04zm1.977-.332-.156.026.066.399q.009.038-.035.047l-.224.037q-.044.007-.05-.032l-.25-1.481q-.006-.04.038-.048l.224-.037q.043-.007.049.033l.142.844.166-.028.286-.463c.016-.026.029-.036.06-.041l.265-.045c.022-.004.036.019.02.038l-.366.584.55.443c.018.013.014.038-.008.042l-.282.047c-.03.005-.047.002-.07-.018l-.426-.349zm.757-1.212q-.008-.04.037-.047l.224-.038c.03-.005.044.005.05.033l.028.172q.009.04-.035.047l-.224.038q-.044.008-.051-.033zm.071.425q-.007-.04.038-.048l.224-.038q.043-.007.048.034l.173 1.028q.008.04-.035.047l-.224.038q-.045.007-.051-.033zm1.514.095c-.018-.11-.044-.126-.176-.104l-.158.027c-.14.023-.185.088-.165.204l.108.645c.004.026-.005.042-.035.047l-.224.037q-.045.007-.051-.032l-.173-1.029q-.007-.04.037-.047l.189-.032q.044-.007.05.033l.026.152q.022-.2.274-.244l.23-.038c.22-.037.33.039.365.25l.129.765q.006.04-.036.048l-.224.037q-.043.007-.05-.032zM32.89 8.836l-.665.112-.057-.34c-.59.026-.982-.197-1.065-.688l-.143-.853.902-.152.108.648c.032.19.184.303.406.265.227-.038.338-.2.306-.39l-.061-.367c-.123-.73-1.708-.28-1.902-1.436l-.098-.583c-.082-.491.21-.873.773-1.057l-.053-.313.664-.112.054.319c.587-.01.998.254 1.08.74l.109.654-.902.151-.084-.502c-.032-.189-.19-.307-.418-.268-.221.037-.328.193-.296.383l.044.264c.134.794 1.68.118 1.909 1.479l.119.707c.082.492-.227.832-.788.999zm2.323-.812-.901.151-.626-3.726-.222.037-.04-.238.207-.556.832-.14zm.38-.858-.482-2.868c-.097-.578.33-1.005 1.098-1.134.772-.13 1.322.134 1.419.712l.481 2.868c.097.577-.34.945-1.113 1.075-.767.129-1.307-.075-1.404-.653m1.58-.476-.422-2.512c-.032-.189-.19-.306-.417-.268-.222.037-.329.194-.297.383l.422 2.511c.032.189.19.307.412.27.226-.038.333-.195.302-.384m1.42-.028-.481-2.868c-.097-.577.33-1.005 1.098-1.133.772-.13 1.322.133 1.419.71l.481 2.869c.097.578-.34.945-1.113 1.075-.767.129-1.307-.075-1.404-.653m1.58-.476-.421-2.511c-.032-.19-.19-.307-.417-.27-.222.038-.328.195-.297.384L39.46 6.3c.032.19.19.307.412.27.226-.038.333-.195.302-.384m-5.499 4.275-.15.025-.041-.154a.33.33 0 0 1-.272.245c-.225.038-.411-.048-.473-.412l-.153-.915c-.062-.368.082-.535.345-.58.266-.044.455.067.517.435l.022.13-.188.032-.017-.106c-.033-.192-.088-.36-.306-.323-.208.035-.217.195-.182.405l.145.864c.048.282.163.32.289.298.167-.028.228-.206.18-.49l-.037-.22-.245.04-.028-.17.432-.072zm.467-.078-.187.031-.306-1.825.187-.032zm.491-.083-.187.032-.307-1.826.62-.104.028.168-.432.073.105.626.42-.071.03.17-.422.07zm1.031-.173-.187.032-.278-1.656-.27.045-.028-.17.728-.122.028.17-.27.046zm1.573-.942.032.19c.062.368-.08.535-.345.579s-.455-.066-.517-.434l-.149-.887c-.062-.368.083-.535.347-.58.265-.044.453.068.515.436l.022.13-.187.031-.018-.106c-.032-.191-.088-.359-.306-.322-.207.035-.216.195-.181.404l.14.838c.036.21.097.358.304.323.218-.037.216-.213.184-.405l-.028-.165zm1.145.486-.187.031-.139-.42-.38.063.005.443-.185.032-.005-1.876.291-.05zm-.38-.553-.33-.99.003 1.045zm1.467.37-.183.03c-.031-.053-.058-.211-.078-.328l-.037-.22c-.036-.214-.166-.206-.258-.19l-.267.044.131.78-.187.032-.307-1.825.498-.084c.318-.053.398.14.439.384l.03.177c.02.125.026.276-.143.366.198.005.23.152.255.306l.046.273c.017.102.038.212.061.255m-.402-1.14-.03-.179c-.038-.227-.102-.293-.276-.264l-.262.044.118.705.274-.046c.163-.027.204-.093.176-.26m1.155 1.014-.498.083-.306-1.825.498-.083c.324-.055.397.135.448.439l.138.824c.051.304.044.507-.28.562m.088-.557-.13-.771c-.046-.276-.09-.352-.288-.319l-.258.043.249 1.486.258-.043c.198-.033.215-.12.17-.396"
      />
    </g>
    <defs>
      <clipPath id="bsh-gift-card-clip">
        <path fill="#fff" d="M0 7.116 42.379 0l4.099 24.413L4.099 31.53z" />
      </clipPath>
    </defs>
  </svg>
)

export const TrashIconV3 = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.0625em"
    height="1.0625em"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <g transform="translate(2.8235 0) scale(1.4118)">
      <path
        fill="#000"
        d="M5.73 8.234v4.782a.8.8 0 0 1-.222.56.77.77 0 0 1-.542.236.76.76 0 0 1-.543-.235.8.8 0 0 1-.221-.561v-4.79a.8.8 0 0 1 .227-.554.754.754 0 0 1 1.08.005.8.8 0 0 1 .222.557m2.309-.79a.75.75 0 0 0-.542.228.8.8 0 0 0-.226.555v4.789a.8.8 0 0 0 .221.56.76.76 0 0 0 .542.236.75.75 0 0 0 .543-.235.8.8 0 0 0 .222-.561V8.234a.8.8 0 0 0-.22-.557.76.76 0 0 0-.54-.232M13 3.189V4.78c0 .305-.083.604-.243.861-.159.258-.387.462-.656.59 0 .047.007.095.007.143v9.031a1.62 1.62 0 0 1-.444 1.123 1.5 1.5 0 0 1-.497.346c-.186.081-.386.124-.588.125H2.42a1.5 1.5 0 0 1-.588-.125 1.5 1.5 0 0 1-.497-.346 1.623 1.623 0 0 1-.444-1.123V6.375A1 1 0 0 1 .9 6.232a1.56 1.56 0 0 1-.656-.59A1.63 1.63 0 0 1 0 4.782V3.187a1.62 1.62 0 0 1 .444-1.123q.215-.224.497-.347c.186-.08.386-.123.588-.124h3.239A1.62 1.62 0 0 1 5.21.47c.142-.148.311-.266.497-.346C5.895.044 6.095 0 6.297 0H6.7c.202.001.402.044.588.125.186.08.355.198.497.346s.255.323.33.516c.077.193.115.399.114.607h3.238a1.5 1.5 0 0 1 1.087.47A1.621 1.621 0 0 1 13 3.187m-2.416 12.218-.005-9.031H2.42v9.031zm.887-12.218H1.533V4.78h9.938z"
      />
    </g>
  </svg>
)

export const GreenStar = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    className={className}
    aria-hidden="true"
  >
    <g transform="scale(1.5)">
      <path
        fill="#0ba94a"
        d="M7.522.345a.5.5 0 0 1 .95 0l1.546 4.756a.5.5 0 0 0 .475.345h5a.5.5 0 0 1 .294.905L11.742 9.29a.5.5 0 0 0-.182.559l1.545 4.755a.5.5 0 0 1-.769.56l-4.045-2.94a.5.5 0 0 0-.588 0l-4.045 2.94a.5.5 0 0 1-.77-.56L4.435 9.85a.5.5 0 0 0-.182-.56L.207 6.352a.5.5 0 0 1 .294-.905h5a.5.5 0 0 0 .475-.345z"
      />
    </g>
  </svg>
)

export const TinyWeeJacket = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    className={className}
    aria-hidden="true"
    width="1.4375em"
    height="1.4375em"
  >
    <g transform="scale(1.0435)">
      <path
        fill="#212419"
        d="m16.721 7.905 1.272 1.271a16.46 16.46 0 0 1 4.24 7.307L23 18.017l-2.3 1.15-.767-1.534a25.8 25.8 0 0 1-3.255-4.978l-.195-.388.384 2.488c.255 1.661.383 3.34.383 5.021 0 .347-.138.679-.383.924l.298.598a.8.8 0 0 1-.463 1.118c-1.16.387-2.376.584-3.599.584H9.897c-1.223 0-2.439-.197-3.6-.584a.8.8 0 0 1-.462-1.118l.298-.598a1.3 1.3 0 0 1-.383-.925c0-1.681.128-3.36.383-5.02l.384-2.488-.195.388a25.8 25.8 0 0 1-3.255 4.978L2.3 19.167 0 18.017l.767-1.534a16.46 16.46 0 0 1 4.24-7.307L6.28 7.905z"
      />
      <path
        fill="#3a402b"
        d="M22.233 16.483a16.46 16.46 0 0 0-4.24-7.307L16.72 7.905H7.428L6.157 9.176a16.46 16.46 0 0 0-4.24 7.307L.92 18.477l1.38.69.767-1.534a25.8 25.8 0 0 0 3.255-4.978l.195-.388-.384 2.488a33 33 0 0 0-.383 5.021c0 .347.138.679.383.924l-.298.598a.8.8 0 0 0 .463 1.118c1.16.387 2.376.584 3.599.584h3.206a11.4 11.4 0 0 0 3.6-.584.8.8 0 0 0 .462-1.118l-.298-.598c.245-.245.383-.578.383-.925 0-1.681-.128-3.36-.383-5.02l-.384-2.488.195.388c.89 1.78 1.982 3.45 3.255 4.978l.767 1.534 2.3-1.15z"
      />
      <path
        fill="#212419"
        d="M12.267 21.451h-1.534a19.2 19.2 0 0 1-4.497-.721l-.103-.03-.298.598a.8.8 0 0 0 .463 1.118c1.16.387 2.376.584 3.599.584h3.206c1.223 0 2.439-.197 3.6-.584a.8.8 0 0 0 .462-1.118l-.298-.598-.104.03c-1.464.418-2.974.66-4.496.721M16.1 4.217H6.9V8.05h9.2z"
      />
      <path
        fill="#3a402b"
        d="M14.184 9.583V7.794a.895.895 0 0 0-.895-.894H9.711a.895.895 0 0 0-.894.894v1.79"
      />
      <path
        fill="#212419"
        d="m3.067 17.633-2.3-1.15L0 18.017l2.3 1.15M22.233 16.483l-2.3 1.15.767 1.534 2.3-1.15"
      />
      <path fill="#5e5e5e" d="M12.267 6.9v15.333a.766.766 0 1 1-1.534 0V6.9" />
      <path fill="#4c4c4c" d="M10.733 6.9v15.333A.766.766 0 0 0 11.5 23V6.9z" />
      <path
        fill="#212419"
        d="m8.046 16.812-.759.109.383 2.683.76-.108zM14.954 16.813l-.384 2.683.76.108.383-2.683zM11.5 0a4.85 4.85 0 0 1 3.753 1.777l.913 1.116a4.8 4.8 0 0 1 1.084 3.035 3.97 3.97 0 0 1-1.766 3.3 2.1 2.1 0 0 1-1.176.355.891.891 0 0 1-.282-1.736l.624-.208a1.559 1.559 0 0 0-.49-3.039H8.84a1.558 1.558 0 0 0-1.262 2.471c.191.266.461.464.772.568l.624.208a.891.891 0 0 1-.282 1.736c-.419 0-.828-.124-1.176-.356a3.97 3.97 0 0 1-1.766-3.3c0-1.106.383-2.178 1.084-3.034l.912-1.116A4.85 4.85 0 0 1 11.5 0"
      />
      <path
        fill="#282c1b"
        d="M15.717 6.16a1.56 1.56 0 0 1-1.067 1.479l-.624.208a.891.891 0 0 0 .282 1.736 2.1 2.1 0 0 0 1.176-.356 3.97 3.97 0 0 0 1.766-3.3 4.8 4.8 0 0 0-1.084-3.034l-.912-1.116a4.85 4.85 0 0 0-3.37-1.756 4.85 4.85 0 0 0-3.371 1.756L7.6 2.893a4.8 4.8 0 0 0-1.083 3.035 3.97 3.97 0 0 0 1.765 3.3c.218.142.46.244.714.299a.889.889 0 0 0-.022-1.68l-.624-.208A1.56 1.56 0 0 1 8.84 4.6h5.32a1.56 1.56 0 0 1 1.557 1.56"
      />
    </g>
  </svg>
)
